import React, { useState } from "react";
import Modal from "./components/Modal";
import DeleteOutlined from "@mui/icons-material/DeleteOutlined";
import { useNavigate } from "react-router-dom";
import apiClient from "../../api/clinet";

interface IDeleteProps {
  id?: number;
}

const DeletePatient: React.FC<IDeleteProps> = (props: IDeleteProps) => {
  const history = useNavigate();
  const id = props.id;
  const [open, setOpen] = useState(false);
  const handleOnClose = () => setOpen(false);
  const onDeleteSubmit = () => {
    apiClient.delete(`/patients/${id}`).then(() => {
      history(0);
    });
    return;
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  return (
    <>
      <DeleteOutlined
        style={{ cursor: "pointer" }}
        fontVariant="outlined"
        onClick={handleClickOpen}
      />

      <Modal
        dialogTitle="Delete Patient's Data"
        dialogContent="Are you sure you want to delete the data of this patient"
        isOpen={open}
        onClose={handleOnClose}
        onSubmit={onDeleteSubmit}
      />
    </>
  );
};

export default DeletePatient;
